module.exports = __webpack_public_path__ + "static/banner-d170be13b376f4c382e2f07d349ce898.png";